import React, { useState, Fragment } from 'react';

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Hidden,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';

import HelpIcon from '@mui/icons-material/Help';

import ServiceIcon from '../ServiceIcon';

import gaEvent from '../../lib/gaEvent';

    
const ChooseService = ({ handleNextStep, services, service, setService }) => {
  
  const [helpDialog, setHelpDialog] = useState(false);

  const selectService = () => {
    gaEvent({
      category: 'Request Quotes',
      action: 'Select Service',
      label: 'Select Service',
    });

    handleNextStep(2);
  }

  services.sort((a, b) => {
    if (a.name.includes('km Service') && b.name.includes('km Service')) {
      const aNum = a.name.replace('km Service', '') * 1;
      const bNum = b.name.replace('km Service', '') * 1;
      if (aNum > bNum) {
        return -1;
      } else {
        return 1;
      }
    }
    if (a.name > b.name) {
      return -1;
    } else {
      return 1;
    }
  });

  services.sort((a, b) => {
    if (a.category == 'Service and Maintenance') {
      return -1;
    }
    if (b.category == 'Service and Maintenance') {
      return 1;
    }
    if (a.category > b.category) {
      return 1;
    } else {
      return -1;
    }
  });

  return <>
    <Box width={{ xs: '100%', md: 800 }}>
      <Autocomplete
        options={services}
        value={service}
        onChange={(event, value) => {
          if (value) {
            setService(value);
            selectService();
          }
        }}
        autoComplete={true}
        autoHighlight={true}
        openOnFocus={true}
        open={true}
        forcePopupIcon={false}
        groupBy={option => option.category}
        getOptionLabel={(option) => (typeof option === 'string' ? option : option.name)}
        renderOption={(props, option) => (
          <Box display="flex" alignItems="center" {...props}>
            <Box height={24} mr={1}>
              {option.category && <ServiceIcon service={option.category} />}
            </Box>
            {option.name}
          </Box>
        )}
        renderInput={params => (
          <TextField
            {...params}
            placeholder="Type to search, e.g. brakes or clutch"
            variant="outlined"
            fullWidth
            autoFocus
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <Box
                  sx={{
                    position: 'absolute',
                    right: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    '& .MuiAutocomplete-endAdornment': {
                      position: 'relative',
                      right: '0 !important',
                      top: 0,
                    },
                  }}
                >
                  {params.InputProps.endAdornment}
                  <Hidden mdDown>
                    <Button color="secondary" onClick={() => setHelpDialog(true)}>
                      I don&apos;t know
                    </Button>
                  </Hidden>
                  <Hidden mdUp>
                    <IconButton onClick={() => setHelpDialog(true)} size="large">
                      <HelpIcon color="secondary" fontSize="small" />
                    </IconButton>
                  </Hidden>
                </Box>
              ),
            }}
          />
        )}
        sx={{
          bgcolor: '#fff',
          borderRadius: 2,
          '& .MuiAutocomplete-popupIndicatorOpen': {
            transform: 'none',
          },
        }}
      />

      <Dialog
        open={helpDialog}
        onClose={() => setHelpDialog(false)}
      >
        <DialogTitle>
          <Box display="flex" alignItems="center">
            Not Sure?
            <Box ml={1} display="flex">
              <ServiceIcon service="Help Me - I'm Not Sure" />
            </Box>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ bgcolor: 'background.default' }}>
          <Typography sx={{ my: 2 }}>Which of the following explains your problem?</Typography>
          <Paper>
            <List sx={{ py: 0 }}>
              {services.map(service => {
                if (service.category === "Help Me - I'm Not Sure") {
                  return (
                    <Fragment key={service.name}>
                      <ListItem
                        button
                        onClick={() => {
                          setService(service);
                          selectService()
                        }}
                      >
                        <ListItemText primary={service.name} />
                      </ListItem>
                      <Divider />
                    </Fragment>
                  );
                }
              })}
            </List>
          </Paper>
        </DialogContent>
        <DialogActions>
          <Button color="secondary" onClick={() => setHelpDialog(false)}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  </>;
};

export default ChooseService;
